export const getItemCount = ({ search: { itemCount, extraItemCount } }) =>
  itemCount + extraItemCount;
